module.exports = __webpack_public_path__ + "static/Adrian-Mouat.97fd6f36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/speakers/Adrian-Mouat.jpg
// module id = 115
// module chunks = 232439770362922 277149362338250